export default "__VITE_ASSET__BqrROmpc__"